import type { ShortFeedItem } from '@/lib/news-types'
import { getShortsCanonicalUrlForItem } from '@/lib/shorts-slug'
import { absoluteSiteTitle, absoluteUrl } from '@/lib/site-seo'

export const SHORTS_DEFAULT_TITLE = 'Shorts'
export const SHORTS_DEFAULT_DESCRIPTION =
  'Dikey kısa video haberler — kaydırarak izleyin.'

/** Next metadata (layout template `| Haber.com` ekler). */
export function formatShortsPageTitle(itemTitle?: string | null): string {
  const title = itemTitle?.trim()
  if (!title) return SHORTS_DEFAULT_TITLE
  return `${title} | Shorts`
}

type ShortMetaItem = Pick<ShortFeedItem, 'id' | 'source' | 'slug' | 'title' | 'youtube' | 'video' | 'x'>

function setMetaContent(
  selector: string,
  content: string,
  attribute: 'content' | 'href' = 'content',
) {
  const el = document.querySelector(selector)
  if (el) el.setAttribute(attribute, content)
}

/** Kaydırma ile aktif short değişince sekme başlığı ve temel meta etiketlerini günceller */
export function syncShortsDocumentMeta(item: ShortMetaItem | null | undefined): void {
  if (typeof document === 'undefined') return

  const pageTitle = absoluteSiteTitle(formatShortsPageTitle(item?.title))
  const description = item?.title?.trim() || SHORTS_DEFAULT_DESCRIPTION
  const canonical = item
    ? getShortsCanonicalUrlForItem(item)
    : absoluteUrl('/shorts')

  document.title = pageTitle

  setMetaContent('meta[name="description"]', description)
  setMetaContent('meta[property="og:title"]', pageTitle)
  setMetaContent('meta[property="og:description"]', description)
  setMetaContent('meta[property="og:url"]', canonical)
  setMetaContent('link[rel="canonical"]', canonical, 'href')
}
